export type ThemeMode = "dark" | "light";

const STORAGE_KEY = "gaole_bo_theme";

function readStoredTheme(): ThemeMode {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw === "light" ? "light" : "dark";
  } catch {
    return "dark";
  }
}

/** Call before React paint (see index.html inline script + main.tsx). */
export function applyTheme(mode: ThemeMode): void {
  document.documentElement.dataset.theme = mode;
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", mode === "light" ? "#f3f0f9" : "#180826");
}

export function getTheme(): ThemeMode {
  return readStoredTheme();
}

export function setTheme(mode: ThemeMode): void {
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // ignore quota errors
  }
  applyTheme(mode);
}

export function toggleTheme(): ThemeMode {
  const next: ThemeMode = getTheme() === "dark" ? "light" : "dark";
  setTheme(next);
  return next;
}

applyTheme(readStoredTheme());
